/* eslint-disable max-lines */
import { describe } from '@elliemae/ds-props-helpers';
import { useControlledDateTimePicker } from './config/useControlledDateTimePicker.js';
import { DSControlledDateTimePickerName } from './constants/index.js';
import { ControlledDateTimePickerContext } from './ControlledDateTimePickerCTX.js';
import { ControlledDateTimePickerContent } from './parts/ControlledDateTimePickerContent.js';
import type { DSControlledDateTimePickerT } from './react-desc-prop-types.js';
import { propTypes } from './react-desc-prop-types.js';

const DSControlledDateTimePicker = (props: DSControlledDateTimePickerT.Props): JSX.Element => {
  const ctx = useControlledDateTimePicker(props);
  return (
    <ControlledDateTimePickerContext.Provider value={ctx}>
      <ControlledDateTimePickerContent />
    </ControlledDateTimePickerContext.Provider>
  );
};

DSControlledDateTimePicker.displayName = DSControlledDateTimePickerName;
const DSControlledDateTimePickerWithSchema = describe(DSControlledDateTimePicker);
DSControlledDateTimePickerWithSchema.propTypes = propTypes;

export { DSControlledDateTimePicker, DSControlledDateTimePickerWithSchema };
